import React, { PropTypes} from 'react'
import { connect } from 'react-redux';

import { Button, Modal } from 'react-bootstrap';
import { hideModal } from '../../actions/ModalAction'

const ConfirmModal = ({ isModalOpen, body, onConfirm, onCancel}) => (

  <Modal show={isModalOpen} >

    <Modal.Body>
      {body}
    </Modal.Body>

    <Modal.Footer>
      <Button onClick={onCancel}>Cancel</Button>
      <Button bsStyle="primary" onClick={onConfirm}>OK</Button>
    </Modal.Footer>

  </Modal>
)

ConfirmModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  body: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default connect()(ConfirmModal)



// WEBPACK FOOTER //
// ./src/pages/modal/ConfirmModal.js